<template>
    <div>
        <b-row>
            <b-col class="text-center">
                <b-button :variant="form_step ? 'secondary' : 'outline-secondary'"
                          size="sm"
                          @click="form_step = true"
                          class="mx-1 mb-2 mt-3"
                >
                    <i class="fa fa-plus"/>
                    <span class="d-none d-md-inline-block ml-1"
                          v-text="' Formulario'"
                    />
                </b-button>

                <b-button :variant="!form_step ? 'secondary' : 'outline-secondary'"
                          size="sm"
                          @click="form_step = false"
                          class="mx-1 mb-2 mt-3"
                          :disabled="!task.steps.length"
                >
                    <i class="fa fa-list-ol"/>
                    Listado
                    <b-badge v-if="!!task.steps.length"
                             :variant="form_step ? 'danger' : 'light'"
                             pill
                    >
                        {{ task.steps.length }}
                    </b-badge>
                </b-button>
            </b-col>
        </b-row>

        <transition mode="out-in"
                    name="component-fade"
        >
            <b-form @submit.prevent="validateFormSteps()"
                    data-vv-scope="task_step"
                    v-if="form_step"
            >
                <b-row>
                    <b-col cols="12"
                           v-if="editing_step"
                    >
                        <b-form-group>
                            <label for="order">Paso</label>
                            <el-input id="order"
                                      name="order"
                                      size="small"
                                      v-model="task_step.order"
                                      disabled
                            />
                        </b-form-group>
                    </b-col>

                    <b-col cols="12">
                        <b-form-group>
                            <label for="name">Nombre</label>
                            <el-input id="name"
                                      name="name"
                                      size="small"
                                      v-model="task_step.name"
                                      data-vv-as=" "
                                      v-validate="'required|min:3|max:255'"
                                      maxlength="255"
                                      show-word-limit
                            />
                            <div class="text-danger small"
                                 v-text="errors.first('task_step.name')"
                            />

                        </b-form-group>
                    </b-col>

                    <b-col cols="12">
                        <b-form-group>
                            <label for="description">Descripción</label>
                            <el-input id="description"
                                      name="description"
                                      type="textarea"
                                      size="small"
                                      v-model="task_step.description"
                                      data-vv-as=" "
                                      v-validate="'required|min:3|max:1000'"
                                      maxlength="1000"
                                      show-word-limit
                            />
                            <div class="text-danger small"
                                 v-text="errors.first('task_step.description')"
                            />
                        </b-form-group>
                    </b-col>

                    <b-col cols="12"
                           v-if="!task_step.url"
                    >
                        <b-form-file id="image"
                                     name="image"
                                     v-model="task_step.image"
                                     data-vv-as=" "
                                     v-validate="'required|mimes:image/jpeg,image/png,image/jpg'"
                                     accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                                     data-vv-delay="1000"
                                     placeholder="Elija un archivo o suéltelo aquí..."
                                     drop-placeholder="Suelta el archivo aquí..."
                                     @change="onFileChange"
                        />
                        <span class="text-danger small"
                              v-text="imageTypeError || errors.first('task_step.image')"
                        />
                    </b-col>

                    <b-col cols="12"
                           class="text-center"
                           v-else
                    >
                        <b-img :src="task_step.url"
                               thumbnail
                               rounded
                               fluid
                               alt="task"
                               style="max-height: 200px; max-width: 200px"
                        />

                        <br>

                        <el-tooltip popper-class="py-1 px-2"
                                    effect="dark"
                                    placement="bottom"
                                    content="Eliminar imagen"
                        >
                            <b-btn variant="danger"
                                   class="m-1"
                                   size="sm"
                                   @click="setUrlToTaskStep(null)"
                            >
                                <i class="fa fa-trash"/> Eliminar
                            </b-btn>
                        </el-tooltip>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col class="text-center">
                        <hr/>

                        <b-btn variant="primary"
                               class="mx-1"
                               @click="validateFormSteps()"
                        >
                            <i class="fa fa-save"/>
                            <span v-if="editing_step">
                                Aceptar
                            </span>
                            <span v-else>
                                Crear
                            </span>
                        </b-btn>
                        <b-btn variant="secondary"
                               class="mx-1"
                               @click="_resetTaskStep()"
                        >
                            <i class="fa fa-close"/> Cancelar
                        </b-btn>
                    </b-col>
                </b-row>
            </b-form>

            <table v-else
                   class="table table-striped table-sm table-hover"
            >
                <thead class="text-white"
                       style="background-color: #097b83"
                >
                <tr>
                    <th width="60px">Orden</th>
                    <th>Nombre</th>
                    <th>Descripción</th>
                    <th></th>
                    <th width="90px">Acciones</th>
                </tr>
                </thead>
                <draggable v-model="task.steps"
                           tag="tbody"
                           @change="sortableOrder"
                           v-if="!!task.steps.length"
                >
                    <tr v-for="step in task.steps"
                        :key="step.name"
                    >
                        <td scope="row">{{ step.order }}</td>
                        <td>{{ step.name }}</td>
                        <td>{{ step.description }}</td>
                        <td>
                            <b-img :src="step.url"
                                   thumbnail
                                   rounded
                                   fluid
                                   alt="task"
                                   style="max-height: 50px; max-width: 50px"
                            />
                        </td>
                        <td>
                            <el-tooltip popper-class="py-1 px-2"
                                        effect="dark"
                                        placement="top-start"
                                        content="Editar"
                            >
                                <b-btn variant="primary"
                                       class="mx-1"
                                       size="sm"
                                       @click="_setTaskStep(step)"
                                >
                                    <i class="fa fa-edit"/>
                                </b-btn>
                            </el-tooltip>

                            <el-tooltip popper-class="py-1 px-2"
                                        effect="dark"
                                        placement="top-start"
                                        content="Eliminar"
                            >
                                <b-btn variant="danger"
                                       class="mx-1"
                                       size="sm"
                                       @click="questionDelete(step)"
                                >
                                    <i class="fa fa-trash"/>
                                </b-btn>
                            </el-tooltip>
                        </td>
                    </tr>
                </draggable>

                <tr v-else>
                    <td colspan="4"
                        class="text-center"
                    >
                        No hay pasos para mostrar
                    </td>
                </tr>
            </table>
        </transition>

        <b-row>
            <b-col>
                <hr/>
                <b-btn variant="secondary"
                       class="float-left"
                       size="sm"
                       @click="setModalShow(false)"
                >
                    <i class="fa fa-close"/> Cancelar
                </b-btn>

                <b-btn variant="primary"
                       class="float-right ml-2"
                       size="sm"
                       @click="increaseStepToModal()"
                       :disabled="!task.steps.length"
                >
                    Siguiente
                    <i class="fa fa-arrow-right"/>
                </b-btn>

                <b-btn variant="info"
                       class="float-right"
                       size="sm"
                       @click="decreaseStepToModal"
                >
                    <i class="fa fa-arrow-left"/> Anterior
                </b-btn>
            </b-col>
        </b-row>
    </div>
</template>


<script>
import {mapMutations, mapState} from 'vuex';
import draggable from 'vuedraggable';
import Swal from 'sweetalert2';

export default {
    name: 'steps',
    components: {
        draggable
    },
    data() {
        return {
            form_step: true,
            dragging: false,
            imageTypeError: ''
        };
    },
    computed: {
        ...mapState('tasks', [
            'task',
            'task_step',
            'editing_step',
            'modal',
            'editing'
        ])
    },
    mounted() {
        this.form_step = !this.editing;
    },
    methods: {
        ...mapMutations('tasks', [
            'increaseStepToModal',
            'decreaseStepToModal',
            'resetTaskStep',
            'addStep',
            'updateStep',
            'setStepsToTask',
            'setTaskStep',
            'setEditingStep',
            'setUrlToTaskStep',
            'setModalShow'
        ]),
        sortableOrder() {
            let steps = JSON.parse(JSON.stringify(this.task.steps));

            let order = 1;

            steps.map(t => {
                t.order = order++;
            });

            this.setStepsToTask(steps);
        },
        _setTaskStep(step) {
            this.setTaskStep(step);

            this.setEditingStep(true);
            this.form_step = true;
        },
        _resetTaskStep() {
            this.resetTaskStep();
            this.setEditingStep(false);
           
            if (this.$validator && this.$validator.reset) {
                this.$validator.reset();
            }
        },
        async questionDelete(step) {
            await Swal.fire({
                title: 'Eliminar',
                text: `¿Está seguro de eliminar el paso No. ${step.order} ?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Si, eliminar'
            }).then(async (result) => {
                if (result) {
                    const steps = this.task.steps.filter(s => s.order !== step.order);

                    this.setStepsToTask(steps);

                    if (!steps.length) {
                        this.form_step = false;
                    }

                    this.sortableOrder();
                    if (this.$validator && this.$validator.reset) {
                        this.$validator.reset();
                    }
                }
            });
        },
        validateFormSteps() {
            this.$validator.validateAll('task_step')
                .then((result) => {
                    if (result) {
                        if (this.editing_step) {
                            this.updateStep();
                        } else {
                            this.addStep();
                        }
                        this.resetTaskStep();
                        this.form_step = false;
                        this.setEditingStep(false);
                        
                        if (this.$validator && this.$validator.reset) {
                            this.$validator.reset();
                        }
                    }
                });
        },
        onFileChange(e) {
            const file = e.target.files[0];
            this.imageTypeError = '';
            this.task_step.image = null;

            if (!file) return;

            const validTypes = ['image/jpeg', 'image/png', 'image/jpg'];
            const maxSize = 20 * 1024 * 1024; // 20MB

            if (!validTypes.includes(file.type)) {
                this.imageTypeError = 'Solo se permiten imágenes PNG o JPG.';
             } else if (file.size > maxSize) {
                this.imageTypeError = 'El tamaño máximo permitido es 20MB.';
            } else {
                this.task_step.image = file;
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = e => {
                    this.setUrlToTaskStep(e.target.result);
                };
                return;
            }
            e.target.value = ''; 
        }
    },
};
</script>

<style>
.component-fade-enter-active, .component-fade-leave-active {
    transition: opacity .3s ease;
}

.component-fade-enter, .component-fade-leave-to {
    opacity: 0;
}
</style>
